<template>
  <div>
    <v-card class="v-card--material pt-2 ma-1 rounded-lg" elevation="2">
      <v-row class="my-1">
        <v-col cols="12" class="pl-6" lg="9" md="9" sm="12" xs="12">
          <span
            class="font-weight-regular headline text-decoration-underline text-capitalize"
            >Bulk Upload Curriculum CMS Resource</span
          >
        </v-col>
        <v-col
          v-if="!$vuetify.breakpoint.xs"
          cols="12"
          lg="3"
          md="3"
          sm="12"
          xs="12"
        >
          <v-card-actions class="d-flex justify-end">
            <v-btn
              class="mb-2"
              title="Upload Resource"
              @click="openBulkUploadDialog()"
              elevation="1"
              top
              color="accent"
            >
              <v-icon left>mdi-plus</v-icon>Upload Resources
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-col v-else cols="12" xs="12">
          <v-card-actions class="d-flex pl-3">
            <v-btn
              class="mb-2"
              title="Upload Resource"
              @click="openBulkUploadDialog()"
              elevation="1"
              top
              color="accent"
            >
              <v-icon left>mdi-plus</v-icon>Upload Resources
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
      <card-component>
        <v-row>
          <v-col cols="12" md="2" sm="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
                <div
                  class="text-button mb-1"
                  v-text="
                    curriculumCMSDetails
                      ? curriculumCMSDetails.academicYear
                      : '--'
                  "
                ></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Business</div>
                <div
                  class="text-button mb-1"
                  v-text="
                    curriculumCMSDetails ? curriculumCMSDetails.business : '--'
                  "
                ></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Program</div>
                <div
                  class="text-button mb-1"
                  v-text="
                    curriculumCMSDetails ? curriculumCMSDetails.program : '--'
                  "
                ></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Week</div>
                <div
                  class="text-button mb-1"
                  v-text="
                    curriculumCMSDetails ? curriculumCMSDetails.week : '--'
                  "
                ></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Theme</div>
                <div class="text-button mb-1" v-text="themeName"></div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table
              item-key="name"
              :headers="resourceTableHeaders"
              :items="weekScheduleList"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.DAY_1="{ item }">
                <div v-if="item.DAY_1.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_1.lessonGuide"
                    :key="'lesson_D1_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_1.lessonGuide"
                    :key="'resource_D1_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:item.DAY_2="{ item }">
                <div v-if="item.DAY_2.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_2.lessonGuide"
                    :key="'lesson_D2_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_2.lessonGuide"
                    :key="'resource_D2_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:item.DAY_3="{ item }">
                <div v-if="item.DAY_3.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_3.lessonGuide"
                    :key="'lesson_D3_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_3.lessonGuide"
                    :key="'resource_D3_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:item.DAY_4="{ item }">
                <div v-if="item.DAY_4.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_4.lessonGuide"
                    :key="'lesson_D4_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_4.lessonGuide"
                    :key="'resource_D4_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:item.DAY_5="{ item }">
                <div v-if="item.DAY_5.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_5.lessonGuide"
                    :key="'lesson_D5_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_5.lessonGuide"
                    :key="'resource_D5_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:item.DAY_6="{ item }">
                <div v-if="item.DAY_6.lessonGuide.length">
                  <span class="d-flex"><b>Lesson Guide</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_6.lessonGuide"
                    :key="'lesson_D6_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'LESSON GUIDE'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'LESSON GUIDE'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'LESSON GUIDE'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <span class="d-flex"><b>Resource Content</b></span>
                  <div
                    v-for="(lesson, index) in item.DAY_6.lessonGuide"
                    :key="'resource_D6_' + index"
                    class="d-flex"
                  >
                    <div
                      v-if="lesson.section === 'RESOURCE CONTENT'"
                      class="mr-auto"
                      :title="lesson.fileName"
                    >
                      {{
                        lesson.fileName.length > 15
                          ? lesson.fileName.substr(0, 15) + '...'
                          : lesson.fileName
                      }}
                    </div>
                    <div>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        :to="{
                          name: 'previewMedia',
                          params: { previewId: lesson.id }
                        }"
                        icon
                        color="primary"
                        small
                        :title="lesson.fileName"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-if="
                          lesson.isDownloadable &&
                          lesson.section === 'RESOURCE CONTENT'
                        "
                        @click="downloadResource(lesson.id)"
                        title="Download"
                      >
                        <v-icon small>mdi-arrow-down-bold</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="lesson.section === 'RESOURCE CONTENT'"
                        @click="deleteResource(lesson.id)"
                        color="error"
                        icon
                        small
                        title="Delete"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </card-component>
    </v-card>
    <v-dialog v-model="bulkUploadDialog" fullscreen>
      <v-card>
        <v-row class="mx-0">
          <v-toolbar class="pl-4" dark color="darkblue">
            <v-toolbar-title> Upload Resources </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-text style="border: solid 1px #e4e4e4">
              <v-row>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <v-file-input
                    :label="'Lesson Guide'"
                    v-model="selectedLessonFiles"
                    multiple
                    :accept="allowedFiles"
                    @change="updateDataLessonTable()"
                  ></v-file-input>
                  <v-divider></v-divider>
                  <v-data-table
                    :headers="lessonHeaders"
                    :items="lessonFileList"
                  >
                    <template v-slot:item.index="{ item }">
                      {{ item.index }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon @click="removeLessonFile(item.index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <p class="has-text-danger">
                    File Name Should be in below format <br />
                    For Day 1 session 1: D1_S1
                  </p>
                  <p class="has-text-danger">
                    Allowed file's: .pdf, .mov, .mpg, .avi, .mp4, .mp3,
                    .wmv,.m4v,.jpg, .png, .jpeg
                  </p>
                  <p class="has-text-danger">
                    File's that are not supported will be removed automatically!
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-text style="border: solid 1px #e4e4e4">
              <v-row>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <v-file-input
                    v-model="selectedResourceFiles"
                    label="Resource Content"
                    multiple
                    @change="updateDataTable"
                    :accept="allowedFiles"
                  ></v-file-input>
                  <v-divider></v-divider>
                  <v-data-table :headers="headers" :items="fileList">
                    <template v-slot:item.index="{ item }">
                      {{ item.index }}
                    </template>
                    <template v-slot:item.downloadable="{ item }">
                      <v-checkbox v-model="item.downloadable"></v-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon @click="removeFile(item.index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <p class="has-text-danger">
                    File Name Should be in below format <br />
                    For Day 1 session 1: D1_S1_1 <br />
                    For Day 1 session 1 Resource 2: D1_S1_2
                  </p>
                  <p class="has-text-danger">
                    Allowed file's: .pdf, .mov, .mpg, .avi, .mp4, .mp3,
                    .wmv,.m4v,.jpg,.png, .jpeg
                  </p>
                  <p class="has-text-danger">
                    File's that are not supported will be removed automatically!
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-card-actions class="justify-end">
              <v-btn @click="closeBulkUploadDialog()"> Close </v-btn>
              <v-btn color="primary" @click="uploadBulkResource()"
                >Upload Resource</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkResponseDialog" width="800px">
      <div>
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Upload Resources </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="bulkUploadResponseHeaders"
              :items="errorFileList"
            >
            </v-data-table>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="bulkResponseDialog = false"> Close</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
export default {
  name: 'bulkUploadCurriculumCMS',
  components: {
    CardComponent
  },
  props: ['folderMapID'],
  data () {
    return {
      errorMessage: null,
      openSnackbar: false,
      weekAtGlanceDetails: [],
      themeName: null,
      totalClassTime: 0,
      weekScheduleList: [],
      theme: '',
      themeTime: '',
      allowedFiles: [
        '.pdf, .mov, .mpg, .avi, .mp4, .mp3, .wmv,.m4v,.jpg, .png, .jpeg',
        'ppt',
        'pptx'
      ],
      lessonType: 'LESSON',
      resourceType: 'RESOURCE',
      isDownloadable: false,
      selectedResourceFiles: [],
      selectedLessonFiles: [],
      fileList: [],
      lessonFileList: [],
      resourceTableHeaders: [
        {
          text: 'Session',
          name: 'Session',
          value: 'Session',
          align: 'center',
          width: '100px',
          sortable: false
        },
        {
          text: 'DAY 1',
          name: 'DAY_1',
          value: 'DAY_1',
          align: 'center',
          width: '300px',
          sortable: false
        },
        {
          text: 'DAY 2',
          name: 'DAY_2',
          value: 'DAY_2',
          align: 'center',
          width: '300px',
          sortable: false
        },
        {
          text: 'DAY 3',
          name: 'DAY_3',
          value: 'DAY_3',
          align: 'center',
          width: '300px',
          sortable: false
        },
        {
          text: 'DAY 4',
          name: 'DAY_4',
          value: 'DAY_4',
          align: 'center',
          width: '300px',
          sortable: false
        },
        {
          text: 'DAY 5',
          name: 'DAY_5',
          value: 'DAY_5',
          align: 'center',
          width: '300px',
          sortable: false
        },
        {
          text: 'DAY 6',
          name: 'DAY_6',
          value: 'DAY_6',
          align: 'center',
          width: '300px',
          sortable: false
        }
      ],
      headers: [
        { text: 'Index', value: 'index' },
        { text: 'Name', value: 'name' },
        { text: 'Downloadable', value: 'downloadable', align: 'center' },
        { text: 'Actions', value: 'actions' }
      ],
      lessonHeaders: [
        { text: 'Index', value: 'index' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions' }
      ],
      curriculumCMSDetails: null,
      bulkUploadDialog: false,
      bulkResponseDialog: false,
      bulkUploadResponse: null,
      errorFileList: [],
      bulkUploadResponseHeaders: [
        { text: 'File Name', value: 'fileName' },
        { text: 'Content Type', value: 'contentType' },
        { text: 'Error Message', value: 'message' }
      ]
    }
  },
  async created () {
    this.create = this.checkModuleAccess('create')
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getWeekScheduleList()
    await this.getCurriculumMapDetails()
  },
  methods: {
    getWeekScheduleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-week/${this.folderMapID}`
        )
        if (res.data.success !== 200 || !res.data.weekAtGlance.length) {
          return this.resetWeekSchedule()
        }
        this.themeName = ''
        let days = res.data.weekAtGlance

        this.themeName = days[0].themeName || null
        this.totalClassTime = days[0].classTime || null
        if (this.totalClassTime) {
          const minutes = Number(this.totalClassTime % 60)
          const hours = Number(this.totalClassTime / 60).toFixed(0)
          this.totalClassTime = `${hours} hours`
          if (minutes > 0) {
            this.totalClassTime = `${hours} hours ${minutes} min `
          }
        }
        days = days.sort(function (a, b) {
          return a.dayName.localeCompare(b.dayName)
        })
        let row = {}
        row['Time'] = []
        row['Session'] = []
        let daysArray = []

        for (let day of res.data.weekAtGlance) {
          day.weekDay = _.orderBy(day.weekDay, 'position', 'asc')
          daysArray.push(day.dayName)
          row[day.dayName] = day.weekDay
        }
        let finalData = []
        let TimeArray = row[daysArray[0]].map((obj) => obj.themeTime)
        let sessionArray = row[daysArray[0]].map((obj) => obj.theme)
        for (let i in TimeArray) {
          let obj = {}
          obj.Time = TimeArray[i]
          obj.Session = sessionArray[i]
          for (let day of daysArray) {
            let dayName = day.split(' ').join('_').toUpperCase()
            obj[dayName] = row[day][i]
          }
          finalData.push(Object.assign({}, obj))
        }
        this.weekScheduleList = finalData
        console.log(this.weekScheduleList)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getCurriculumMapDetails: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-curriculum-map-details/${this.folderMapID}`
        )
        console.log(res)
        if (res.data.success !== 200) {
          const errorMessage = `Something wen't wrong!`
          this.errMsg(errorMessage)
        }
        this.curriculumCMSDetails = res.data.curriculumCMSDetails
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    openBulkUploadDialog () {
      this.bulkUploadDialog = true
    },
    updateDataTable () {
      this.fileList = this.selectedResourceFiles.map((file, index) => ({
        index: index + 1,
        name: file.name,
        downloadable: false
      }))
    },
    updateDataLessonTable () {
      this.lessonFileList = this.selectedLessonFiles.map((file, index) => ({
        index: index + 1,
        name: file.name
      }))
    },
    removeFile (index) {
      const fileIndex = this.fileList.findIndex((file) => file.index === index)
      if (fileIndex !== -1) {
        this.fileList.splice(fileIndex, 1)
        this.fileList.forEach((file, index) => {
          file.index = index + 1
        })
        this.selectedResourceFiles.splice(fileIndex, 1)
      }
    },
    removeLessonFile (index) {
      const fileIndex = this.lessonFileList.findIndex(
        (file) => file.index === index
      )
      if (fileIndex !== -1) {
        this.lessonFileList.splice(fileIndex, 1)
        this.lessonFileList.forEach((file, index) => {
          file.index = index + 1
        })
        this.selectedLessonFiles.splice(fileIndex, 1)
      }
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    deleteResource: async function (resID) {
      try {
        let res = await http.put(
          `${constants.API_URL}/api/curriculum_cms/in-active-file/${resID}`
        )
        if (res.status === 200) {
          this.$dialog.message.info('File deleted successfully.', {
            position: 'top-center',
            color: 'success',
            timeout: 4000
          })
        } else {
          this.$dialog.message.error('Failed to delete file.', {
            position: 'top-center',
            color: 'error',
            timeout: 4000
          })
        }
        await this.getWeekScheduleList()
      } catch (e) {
        this.$dialog.message.error(e.response.data.message, {
          position: 'top-center',
          color: 'error',
          timeout: 4000
        })
      }
    },
    downloadResource: async function (resID) {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-signed-url/${resID}`
        )
        if (res.status === 200) {
          window.open(res.data.filePath)
        } else {
          return this.$dialog.error({
            text: 'Failed to open file.',
            title: 'Error'
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: e.response.data.message,
          title: 'Error'
        })
      }
    },
    closeBulkUploadDialog () {
      this.bulkUploadDialog = false
      this.lessonFileList = []
      this.selectedLessonFiles = []
      this.selectedResourceFiles = []
      this.fileList = []
    },
    uploadBulkResource: async function () {
      try {
        const formData = new FormData()
        const resourceFileData = this.fileList.map((file) => ({
          fileName: file.name,
          isDownloadable: file.downloadable
        }))
        const lessonFileData = this.lessonFileList.map((file) => ({
          fileName: file.name,
          isDownloadable: false
        }))
        for (let i in this.selectedResourceFiles) {
          formData.append('resourceFiles', this.selectedResourceFiles[i])
        }
        for (let i in this.selectedLessonFiles) {
          formData.append('lessonFiles', this.selectedLessonFiles[i])
        }
        formData.append('lessonFileData', JSON.stringify(lessonFileData))
        formData.append('resourceFileData', JSON.stringify(resourceFileData))
        const response = await http.post(
          `${constants.API_URL}/api/curriculum_cms/upload-bulk-week-resources/${this.folderMapID}`,
          formData
        )
        this.bulkUploadDialog = false
        if (response.status === 200) {
          this.bulkUploadResponse = response.data.response
          this.errorFileList = response.data.errorFiles
          this.bulkResponseDialog = true
          this.bulkUploadDialog = false
          this.lessonFileList = []
          this.selectedLessonFiles = []
          this.selectedResourceFiles = []
          this.fileList = []
          console.log('errorFileList::::', this.errorFileList)
          await this.getWeekScheduleList()
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
    }
  }
}
</script>
